import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { fetchComments, postComments } from '../../Services/action';
import { GENERAL } from '../../../Analyst/Cases/constants';
import { toast } from 'react-toastify';
import moment from 'moment';
import { DATE_TIME_FORMAT } from '../../../constants';
import { identifyRole } from './helper';
import './style.scss';

class CommentSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            comment: '',
            commentsList: [],
            warning: null
        };
    }
    componentDidMount() {
        this.props.fetchComments(this.props.taskId)
    }
    componentDidUpdate(prevProps) {
        const { fetchCommentList, postResponse } = this.props
        if (!fetchCommentList.error && fetchCommentList !== prevProps.fetchCommentList) {
            this.setState({
                commentsList: this.props.fetchCommentList,
                warning: this.props.fetchCommentList.length === 0 ? "No Comments Available" : ""
            })
            this.props.commentSectionCallback()
        }
        else if (fetchCommentList.error && fetchCommentList !== prevProps.fetchCommentList) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation"></i>&nbsp;Error in fetching Comments
                </div>
            );
        }
        if (postResponse.error && postResponse !== prevProps.postResponse) {
            toast.error(
                <div>
                    <i className="fa fa-exclamation"></i>&nbsp;Couldn&#39;t Add Comment
                </div>
            );
        }
        else if (!postResponse.error && postResponse !== prevProps.postResponse) {
            this.setState({
                comment: '',
                commentsList: postResponse
            }, () => {
                toast.success(
                    <div>
                        <i className="fa fa-check"></i>&nbsp;Comment Successfully Added
                    </div>
                );
            })
        }

    }
    postComment = () => {
        let reqbody = {
            type: GENERAL,
            comment: this.state.comment
        }
        this.props.postComments(this.props.taskId, reqbody)
    }
    handleInputChange = (e) => {
        this.setState({
            comment: e.target.value
        })
    }
    render() {
        let disable = this.state.comment.length > 0 ? false : true
        let comments
        if (this.state.commentsList.length > 0) {
            comments = <ul className="comment-list pr-1">
                {
                    this.state.commentsList.map((val, index) => {
                        return <li key={index} className="w-100 mb-2">
                            <h6>{identifyRole(val.sender)}</h6>
                            <p className="bg-secondary mb-0 p-3 radius-5 text-white">{val.comment}</p>
                            <div className="text-right font-size-small">
                                <p>{moment(val.date).format(DATE_TIME_FORMAT)}</p>
                            </div>
                        </li>
                    })
                }
            </ul>
        }
        return (
            <div>
                {comments}
                <strong>{this.state.warning}</strong>
                <div>
                    <textarea id="comment" name="comment" rows="2" cols="70"
                        className="mt-4 w-100 radius-5" placeholder="Comment here..." onChange={this.handleInputChange} value={this.state.comment}>
                    </textarea>
                    <br />
                    <Button color="primary" className="mt-5" onClick={this.postComment} disabled={disable}>Comment</Button>
                    <Button color="danger" className="mt-5 ml-3" onClick={this.props.toggle}>Cancel</Button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => ({
    fetchCommentList: state.commonReducer.fetchComments,
    postResponse: state.commonReducer.postComments,
})

const mapDispatchToProps = (dispatch) => ({
    fetchComments: (data) => { dispatch(fetchComments(data)) },
    postComments: (id, data) => { dispatch(postComments(id, data)) },

});

export default connect(mapStateToProps, mapDispatchToProps)(CommentSection)
